import React, { useEffect } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import ContentSection from './ContentSection';
import pageContent from '../../data/pageContent';

function DynamicPage() {
  const { slug } = useParams();

  // Log the slug for debugging
  useEffect(() => {
    console.log("Current slug:", slug);
    console.log("Available pages:", Object.keys(pageContent));
  }, [slug]);

  // If slug is undefined (for the homepage), use pageContent[""] as default
  const content = pageContent[slug || ""];  // If slug is undefined, fallback to "home" content

  // If content is not found (invalid slug or undefined), redirect to home
  if (!content) {
    return <Navigate to="/" />;
  }

  const CustomContent = content.customContent;

  return (
    <ContentSection
      imageClass={content.imageClass || "hero bg-default"}
      title={content.title || "Page"}
      text={content.text || ""}
    >
      {CustomContent && <CustomContent />}
    </ContentSection>
  );
}

export default DynamicPage;
